import { Paper as MUIPaper, PaperProps } from '@mui/material';

export { type PaperProps } from '@mui/material';

export function Paper(props: PaperProps) {
  return <MUIPaper {...props} />;
}
